module.exports = __webpack_public_path__ + "img/elli.7273f81e.svg";